import axios from 'axios'

export const AxiosInterceptor = () => {
  const baseUrl = process.env.REACT_APP_BASEURL

  axios.defaults.baseURL = baseUrl
  axios.defaults.headers.post['Content-Type'] = 'application/json'

  axios.interceptors.request.use(
    function (config) {
      config.headers['Access-Control-Allow-Origin'] = '*'

      const userObject = localStorage.getItem('__TG-EMP')

      if (userObject !== null && userObject !== 'null' && userObject) {
        const token = userObject && JSON.parse(userObject).token

        config.headers.Authorization = `Bearer ${token}`
      }

      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    },
  )

  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      // Do something with request error
      console.log('error.response')
      console.log(error.response)

      if (error.response && error.response.data.error === 'Unauthorized') {
        // Redirect to the login page
        localStorage.removeItem('__TG-EMP')
        window.location.href = '/login'
      }

      if (error.response && error.response.data.error === 'Access token expired') {
        // Redirect to the login page
        localStorage.removeItem('__TG-EMP')
        window.location.href = '/login'
      }
      return Promise.reject(error)
    },
  )
}
